<template>
  <v-snackbar
    app
    v-model="show"
    multi-line
    timeout="-1"
    top
    color="blue-grey lighten-5"
  >
    <v-alert
      v-for="(item, i) in notifications"
      :key="i"
      :type="item.type"
      prominent
      @input="clear(i)"
    >
      <v-row align="center">
        <v-col class="grow"> {{ item.text }} </v-col>
        <v-col class="shrink">
          <v-btn icon @click.stop="clear(i)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";

export default {
  name: "Notification",
  data: () => ({}),
  computed: {
    ...mapGetters({ notifications: GETTERS.NOTIFICATIONS }),
    show() {
      return this.notifications.length !== 0;
    },
  },
  methods: {
    ...mapMutations({ clear: MUTATIONS.NOTIFICATION_CLEAR }),
  },
};
</script>
